export enum vehicleType {
  MPV = 'MULTIPURPOSE PASSENGER VEHICLE (MPV)',
  TRUCK = 'TRUCK',
  PASSENGER = 'PASSENGER CAR',
}
